export default __webpack_public_path__ + "static/media/whitePaint.c5141f21.jpg";